// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «База фактів (RAG)» (Fact base (RAG), ключ `rag`, група `ai-management`). */
export const factBaseRagManifest: IModuleManifest = {
  key: 'rag',
  group: 'ai-management',
  slug: 'fact-base-rag',
  prefix: 'RAG',
  name: { en: 'Fact base (RAG)', uk: 'База фактів (RAG)' },
  entities: [
    { key: 'rag', slug: 'rag', name: { en: 'Facts', uk: 'Факти' }, main: true },
    { key: 'ragsrc', slug: 'ragsrc', name: { en: 'Sources', uk: 'Джерела' }, main: false },
    { key: 'ragtest', slug: 'ragtest', name: { en: 'Evaluation questions', uk: 'Контрольні питання' }, main: false },
  ],
  loadState: () => import('./state/factBaseRagSlice').then((m) => m.factBaseRagSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
